import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CustomerForm from "./CustomerForm";
import StoreNotSelected from "./StoreNotSelected";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Home page */}
        <Route path="/" element={<StoreNotSelected />} />

        {/* Root-level slug */}
        <Route path="/:storeSlug" element={<CustomerForm />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
